'use client';
import {styled} from '@mui/material/styles';
import {Typography} from '../../primitives';

export interface FilterChipProps {
  label: string;
  active: boolean;
  onSelect: () => void;
}

const Chip = styled('button', {shouldForwardProp: propName => propName !== '$active'})<{$active: boolean}>(({theme, $active}) => ({
  cursor: 'pointer',
  border: $active ? '1px solid transparent' : `1px solid ${theme.palette.colors.border.neutral.default}`,
  borderRadius: theme.radii.md,
  padding: theme.spacing(1.25, 2.25),
  whiteSpace: 'nowrap',
  backgroundColor: $active ? theme.palette.colors.surface.secondary.active : theme.palette.colors.surface.neutral.default,
}));

export function FilterChip({label, active, onSelect}: FilterChipProps) {
  return (
    <Chip
      $active={active}
      aria-pressed={active}
      onClick={() => {
        onSelect();
      }}
    >
      <Typography
        size="body-2"
        weight="medium"
        as="span"
        sx={{
          letterSpacing: '-0.015em',
          color: theme => (active ? theme.palette.colors.text.secondary.onColor : theme.palette.colors.text.neutral.default),
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Chip>
  );
}

FilterChip.displayName = 'FilterChip';
